(function(){
if(window.__opalQuickAddNudgeV3)return;window.__opalQuickAddNudgeV3=true;
var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
var modal,currentProduct,currentVariant,selectedOptions={},quantity=1,toastTimer;

function parseProduct(card){var n=card&&card.querySelector('[data-opal-product-json]');if(!n)return null;try{return JSON.parse(n.textContent||'{}')}catch(e){console.error(e);return null}}
function availableVariants(){return(currentProduct&&currentProduct.variants||[]).filter(function(v){return v&&v.available})}
function firstAvailableVariant(){return availableVariants()[0]||null}
function stateFromVariant(v){var x={};(currentProduct.options||[]).forEach(function(o){x[o.position]=v.options[Number(o.position)-1]});return x}
function findBestVariant(position,value){var av=availableVariants();var exact=av.find(function(v){return(currentProduct.options||[]).every(function(o){var expected=Number(o.position)===Number(position)?value:selectedOptions[o.position];return String(v.options[Number(o.position)-1])===String(expected)})});if(exact)return exact;return av.find(function(v){return String(v.options[Number(position)-1])===String(value)})||null}
function isColour(n){n=String(n||'').toLowerCase();return n.includes('color')||n.includes('colour')||n.includes('plating')||n.includes('metal')}
function isSize(n){n=String(n||'').toLowerCase();return n.includes('size')}
function colourBackground(v){var r=String(v||'').trim().toLowerCase(),m={'white':'#f6f3ef','red':'#c83b3b','green':'#5e8863','blue':'#557da8','pink':'#e9a9bd','mint green':'#a9d7c0','mint pink':'#edbdc9','black':'#222','gold':'#d2a84a','golden':'#d2a84a','silver':'#c8c8c8','rose gold':'#c9907e'};if(m[r])return m[r];if(r.includes('-')){var p=r.split('-').map(function(x){return m[x.trim()]||'#ece8e3'});return'linear-gradient(135deg,'+p[0]+' 0 50%,'+p[1]+' 50% 100%)'}return'#ece8e3'}

function ensureModal(){if(modal)return;modal=document.createElement('div');modal.className='opal-quickadd';modal.hidden=true;modal.innerHTML='<div class="opal-quickadd__overlay" data-opal-close></div><div class="opal-quickadd__dialog" role="dialog" aria-modal="true"><button class="opal-quickadd__close" type="button" data-opal-close>&times;</button><div class="opal-quickadd__top"><img class="opal-quickadd__image" alt=""><div><h3 class="opal-quickadd__title"></h3><div class="opal-quickadd__price-row"><span class="opal-quickadd__compare"></span><span class="opal-quickadd__price"></span></div></div></div><div class="opal-quickadd__rule"></div><div class="opal-quickadd__options"></div><div class="opal-quickadd__bottom"><div class="opal-quickadd__qty"><button type="button" data-opal-qty-minus>−</button><input type="number" min="1" value="1" data-opal-qty><button type="button" data-opal-qty-plus>+</button></div><button class="opal-quickadd__add" type="button" data-opal-modal-add>Add to cart →</button></div><a class="opal-quickadd__details" href="#" data-opal-details>View full details →</a></div>';document.body.appendChild(modal);
modal.addEventListener('click',function(e){if(e.target.closest('[data-opal-close]')){closeModal();return}var b=e.target.closest('[data-opal-option-choice]');if(b){chooseOption(b);return}if(e.target.closest('[data-opal-qty-minus]')){quantity=Math.max(1,quantity-1);modal.querySelector('[data-opal-qty]').value=quantity;return}if(e.target.closest('[data-opal-qty-plus]')){quantity++;modal.querySelector('[data-opal-qty]').value=quantity;return}var a=e.target.closest('[data-opal-modal-add]');if(a)addCurrentVariant(a)});
modal.querySelector('[data-opal-qty]').addEventListener('change',function(e){quantity=Math.max(1,parseInt(e.target.value,10)||1);e.target.value=quantity});
document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)closeModal()})}

function renderOptions(){var c=modal.querySelector('.opal-quickadd__options');c.innerHTML='';var cfg=currentProduct.config||{};(currentProduct.options||[]).forEach(function(o){if(String(o.name).toLowerCase()==='title'&&o.values&&o.values.length===1)return;if(isColour(o.name)&&cfg.showColorOptions===false)return;if(isSize(o.name)&&cfg.showSizeOptions===false)return;var g=document.createElement('div');g.className='opal-quickadd__option';var h=document.createElement('div');h.className='opal-quickadd__option-title';h.textContent=o.name;g.appendChild(h);var vals=document.createElement('div');vals.className='opal-quickadd__values';(o.values||[]).forEach(function(v){var b=document.createElement('button');b.type='button';b.className='opal-quickadd__value';b.setAttribute('data-opal-option-choice','');b.setAttribute('data-position',o.position);b.setAttribute('data-value',v);if(isColour(o.name)){b.classList.add('opal-quickadd__value--colour');var d=document.createElement('span');d.className='opal-quickadd__colour-dot';d.style.background=colourBackground(v);b.appendChild(d);var l=document.createElement('span');l.textContent=v;b.appendChild(l)}else b.textContent=v;vals.appendChild(b)});g.appendChild(vals);c.appendChild(g)});syncUI()}
function syncUI(){modal.querySelectorAll('[data-opal-option-choice]').forEach(function(b){var p=Number(b.getAttribute('data-position')),v=b.getAttribute('data-value');b.classList.toggle('is-selected',String(selectedOptions[p])===String(v));b.disabled=!availableVariants().some(function(x){return String(x.options[p-1])===String(v)})})}
function updateVariantUI(){if(!currentVariant)return;var img=modal.querySelector('.opal-quickadd__image');img.src=currentVariant.image||currentProduct.featuredImage||'';img.alt=currentProduct.title||'';modal.querySelector('.opal-quickadd__price').textContent=currentVariant.priceFormatted||'';var cmp=modal.querySelector('.opal-quickadd__compare');if(Number(currentVariant.compareAtPrice||0)>Number(currentVariant.price||0)){cmp.textContent=currentVariant.compareAtPriceFormatted||'';cmp.hidden=false}else{cmp.textContent='';cmp.hidden=true}syncUI()}
function chooseOption(b){var p=Number(b.getAttribute('data-position')),v=b.getAttribute('data-value'),variant=findBestVariant(p,v);if(!variant)return;currentVariant=variant;selectedOptions=stateFromVariant(variant);updateVariantUI()}
function openModal(product){ensureModal();currentProduct=product;currentVariant=firstAvailableVariant();if(!currentVariant)return;selectedOptions=stateFromVariant(currentVariant);quantity=1;var cfg=currentProduct.config||{};modal.querySelector('.opal-quickadd__title').textContent=currentProduct.title||'';var details=modal.querySelector('[data-opal-details]');details.href=currentProduct.url||'#';details.hidden=cfg.showFullDetails===false;var qty=modal.querySelector('.opal-quickadd__qty');qty.hidden=cfg.showQuantity===false;modal.querySelector('[data-opal-qty]').value='1';var addBtn=modal.querySelector('[data-opal-modal-add]');addBtn.textContent=(cfg.popupButtonText||'Add to Cart')+' →';renderOptions();updateVariantUI();modal.hidden=false}
function closeModal(){if(!modal)return;modal.hidden=true;currentProduct=null;currentVariant=null;selectedOptions={}}
function showToast(m){var t=document.querySelector('.opal-cart-toast');if(!t){t=document.createElement('div');t.className='opal-cart-toast';document.body.appendChild(t)}t.textContent=m;t.classList.add('is-visible');clearTimeout(toastTimer);toastTimer=setTimeout(function(){t.classList.remove('is-visible')},2200)}
function updateCartCounts(cart){if(!cart)return;['[data-cart-count]','[data-header-cart-count]','.js-cart-count','.header__cart-count','.cart-count'].forEach(function(s){document.querySelectorAll(s).forEach(function(n){n.textContent=cart.item_count})})}
function notifyTheme(cart,item){['cart:refresh','cart:updated','cart:change','cart:changed'].forEach(function(name){document.dispatchEvent(new CustomEvent(name,{bubbles:true,detail:{cart:cart,item:item,source:'opal-quick-add'}}))})}
function sleep(ms){return new Promise(function(resolve){setTimeout(resolve,ms)})}

function fireOpalCartEvent(cart,item){
  window.dispatchEvent(new CustomEvent('opal:cart-added',{
    detail:{cart:cart,item:item,source:'opal-quick-add'}
  }));
}

async function addCurrentVariant(button){
  if(!currentVariant)return;

  var old=button.textContent;
  button.disabled=true;
  button.classList.remove('is-success');
  button.classList.add('is-adding','is-nudging');
  button.textContent='Adding…';

  setTimeout(function(){
    button.classList.remove('is-nudging');
  },150);

  try{
    var r=await fetch(root+'cart/add.js',{
      method:'POST',
      credentials:'same-origin',
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json'
      },
      body:JSON.stringify({
        items:[{
          id:Number(currentVariant.id),
          quantity:quantity
        }]
      })
    });

    var added=await r.json();

    if(!r.ok){
      throw new Error(
        added.description||
        added.message||
        'Could not add this item.'
      );
    }

    var cr=await fetch(root+'cart.js',{
      credentials:'same-origin',
      headers:{'Accept':'application/json'}
    });

    var cart=await cr.json();

    updateCartCounts(cart);
    fireOpalCartEvent(cart,added);

    button.classList.remove('is-adding');
    button.classList.add('is-success');
    button.textContent='Added ✓';

    await sleep(650);

    closeModal();
  }catch(e){
    button.classList.remove('is-adding','is-success');
    button.textContent=old;
    showToast(e.message||'Could not add this item.');
    return;
  }finally{
    button.disabled=false;
    button.classList.remove('is-adding','is-success','is-nudging');
    button.textContent=old;
  }
}

async function addDirectVariant(trigger,product,variant){
  var label=trigger.querySelector('.opal-card-atc__label');
  var originalText=label ? label.textContent : 'Add to Cart';

  currentProduct=product;
  currentVariant=variant;
  quantity=1;

  trigger.disabled=true;
  trigger.classList.remove('is-success');
  trigger.classList.add('is-adding','is-nudging');

  if(label)label.textContent='Adding…';

  setTimeout(function(){
    trigger.classList.remove('is-nudging');
  },150);

  try{
    var r=await fetch(root+'cart/add.js',{
      method:'POST',
      credentials:'same-origin',
      headers:{
        'Content-Type':'application/json',
        'Accept':'application/json'
      },
      body:JSON.stringify({
        items:[{
          id:Number(variant.id),
          quantity:1
        }]
      })
    });

    var added=await r.json();

    if(!r.ok){
      throw new Error(
        added.description||
        added.message||
        'Could not add this item.'
      );
    }

    var cr=await fetch(root+'cart.js',{
      credentials:'same-origin',
      headers:{'Accept':'application/json'}
    });

    var cart=await cr.json();

    updateCartCounts(cart);
    fireOpalCartEvent(cart,added);

    trigger.classList.remove('is-adding');
    trigger.classList.add('is-success');

    if(label)label.textContent='Added ✓';

    await sleep(900);
  }catch(error){
    console.error('Opal Quick Add:',error);
    showToast(error.message||'Could not add this item.');
  }finally{
    trigger.classList.remove('is-adding','is-success','is-nudging');
    trigger.disabled=false;

    if(label)label.textContent=originalText;

    currentProduct=null;
    currentVariant=null;
  }
}

document.addEventListener('click', function (e) {
  var trigger = e.target.closest
    ? e.target.closest('[data-opal-card-cta]')
    : null;

  if (!trigger || trigger.disabled) return;

  /*
   * Capture our collection CTA before third-party cart scripts.
   */
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  var card = trigger.closest('[data-opal-card-product]');
  if (!card) return;

  var product = parseProduct(card);

  if (!product) {
    console.error('Opal Quick Add: product data could not be read.');
    return;
  }

  var cfg = product.config || {};

  if (cfg.quickAddEnabled === false) {
    window.location.href = product.url;
    return;
  }

  var meaningfulOptions = (product.options || []).filter(function (option) {
    return !(
      String(option.name).toLowerCase() === 'title' &&
      option.values &&
      option.values.length === 1
    );
  });

  var available = (product.variants || []).filter(function (variant) {
    return variant && variant.available;
  });

  /*
   * Simple product:
   * stay on the page and use the Palmonas-style micro feedback.
   */
  if (meaningfulOptions.length === 0 && available.length === 1) {
    addDirectVariant(trigger, product, available[0]);
    return;
  }

  /*
   * Products with colour / size still need a selector.
   * Give a tiny button nudge first, then open our compact quick-add UI.
   */
  trigger.classList.add('is-nudging');
  trigger.disabled=true;

  setTimeout(function(){
    trigger.classList.remove('is-nudging');
    trigger.disabled=false;
    openModal(product);
  },140);

}, true);
})();
